import _ from "lodash"
import defaultMessages from "../../i18n/default.messages"

let messages = {
    messages: {
        'es-MX': {
            moduleTitle: 'Atributos',
            tblTitle: 'Lista de Atributos de "{name}"',
            tblbutton: 'Nuevo Atributo',
            mdlSave: 'Aceptar',
            mdlCancel: 'Cancelar',
            mdltext1: 'Atributo',
            mdltext2: 'Descripción',
            lblName: 'Nombre',
            lblDescription: 'Descripción',
            lblMinValue: 'Cantidad',
            lblmMxValue: 'Descripción',
            dlgDeleteMapTitle: 'Eliminar atributo',
            dlgUploadTitle: 'Actualizar atributo',
            lblback: 'Atras',


            headerName: 'Nombre',
            headerValue: 'Valor',
            headerAction: 'Acciones',

            lblSearch: 'Buscar',
            lblEdit: 'Editar',
            lblDelete: 'Eliminar atributo',

            lblEdit2: 'Los Atributos de tipo Tiene/No tiene no pueden ser actualizados',
            lbldelete1: 'Estás apunto de eliminar el atributo',
            lbldelete2: 'Estas Seguro?',

        },
        en: {
            moduleTitle: 'Attributes',
            tblTitle: 'Attributes list for "{name}"',
            tblbutton: 'New Attributes',
            mdlSave: 'Save',
            mdlCancel: 'Cancel',
            mdltext1: 'Attributes',
            mdltext2: 'Description',
            lblName: 'Name',
            lblDescription: 'Description',
            lblMinValue: 'Quantity',
            lblmMxValue: 'Description',
            dlgDeleteMapTitle: 'Delete attributes',
            dlgUploadTitle: 'Upload attributes',
            lblback: 'Go back',

            headerName: 'Name',
            headerValue: 'Value',
            headerAction: 'Actions',

            lblSearch: 'Search',
            lblEdit: 'Edit',
            lblDelete: 'Delete attribute',

            lblEdit2: 'Attributes of type Has / Does not have cannot be updated',
            lbldelete1: 'You are about to remove the attribute',
            lbldelete2: 'Are you sure?',



        }
    }
}

export default _.merge(messages, defaultMessages)